"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Alert_1 = __importDefault(require("../Alert"));
const core_1 = require("@material-ui/core");
const useStyles = core_1.makeStyles((theme) => ({
    headerContainer: {
        marginBottom: theme.spacing(2),
    },
    description: {
        padding: theme.spacing(1, 0),
        color: theme.palette.text.secondary,
    },
    contentContainer: {
        marginBottom: theme.spacing(2),
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));
/**
 * A form represents a document section that contains interactive controls to submit information to a web server.
 */
const Form = (_a) => {
    var { header, description, errorText, actions, children, FormComponent } = _a, formProps = __rest(_a, ["header", "description", "errorText", "actions", "children", "FormComponent"]);
    const classes = useStyles();
    const content = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.headerContainer },
            react_1.default.createElement(core_1.Typography, { variant: "h3" }, header),
            description && (react_1.default.createElement(core_1.Typography, { className: classes.description, variant: "body1" }, description)),
            errorText && react_1.default.createElement(Alert_1.default, { type: "error" }, errorText)),
        react_1.default.createElement("div", { className: classes.contentContainer }, children),
        react_1.default.createElement("div", { className: classes.actions }, actions)));
    return FormComponent ? (react_1.default.createElement(FormComponent, Object.assign({}, formProps), content)) : (react_1.default.createElement("form", Object.assign({}, formProps), content));
};
exports.default = Form;
//# sourceMappingURL=index.js.map